<!-- ContactSection.svelte -->
<script>
  // You can import an image here or use a URL directly in the src attribute below
</script>

<div class="contact-section">
  <div class="contact-image">
    <img src="../images/backgrounds/OldOffice.jpg" alt="FWF Ocean Blvd Office">
  </div>
  <div class="contact-content">
  <div class="content-container">
    <h2>Contact Us</h2>
    <br>
    <p>Give us a call or send us a note! Our attentive staff will respond to you personally.</p><br><br><br>
    <ul class="custom-list">
      <li class="phone">(562) 433-5388</li>
      <li class="address">
        PO Box 41505
        <br>Long Beach, CA 90853
        <br>United States of America
      </li>
      <li class="email"><a href="mailto:info@freedomwritersfoundation.org">info@freedomwritersfoundation.org</a></li>
      <li class="facebook"><a href="https://www.facebook.com/freedomwritersfoundation">@freedomwritersfoundation</a></li>
      <li class="instagram"><a href="https://www.instagram.com/freedomwritersfoundation">@freedomwritersfoundation</a></li>
      <li class="twittercurrentlyx"><a href="https://www.twitter.com/freedomwriters">@freedomwriters</a></li>
      <!-- More list items -->
    </ul>
    </div>
  </div>
</div>

<style>
.custom-list {
  list-style: none; /* Remove default list styling */
  padding-left: 0; /* Remove default padding */
}

.custom-list li {
  display: flex;
  align-items: center;
  padding-left: 24px; /* Make room for the SVG */
  align-items: center;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 16px 16px; /* Size of the SVG */
  margin-bottom: 14px; /* Space between items */
}

.custom-list li::before {
  content: '';
  display: block;
  width: 34px; /* Width of the SVG */
  height: 34px; /* Height of the SVG */
  margin-right: 8px; /* Space between the SVG and the text */
}

.custom-list .phone::before {
  background-image: url('/images/logos/phone.svg');
}
.custom-list .address::before {
  background-image: url('/images/logos/mail.svg');
}

.custom-list .email::before {
  background-image: url('/images/logos/email.svg');
}

.custom-list .facebook::before {
  background-image: url('/images/logos/facebook.svg');
}
.custom-list .instagram::before {
  background-image: url('/images/logos/instagram.svg');
}
.custom-list .twittercurrentlyx::before {
  background-image: url('/images/logos/twitter.svg');
}

/* Repeat for each item as needed */

h2 {
  font-family: 'Oswald';
  font-size: 2.5rem;
  color: #f7931e;
}

  .contact-section {
    display: flex;
    flex-wrap: wrap; /* This will allow items to wrap on smaller screens */
    align-items: stretch; /* This makes the children of the container the same height */
  }

  .contact-image {
    flex: 1; /* Take up as much space as content on larger screens */
    background-image: url('/images/backgrounds/OldOffice.jpg'); /* Replace with your actual image */
    background-size: cover; /* Cover the div with the image */
    background-position: center;
  }

  .contact-image img {
    object-fit: cover;
    display: block; /* Hide the img tag, using background-image instead */
    width: 100%;
    height: 100%;
  }

  .contact-content {
    flex: 1; /* Take up as much space as image on larger screens */
    /* Add more styling as needed */
  }
  .content-container {
  margin: 2rem;
  }

  @media (max-width: 768px) {
    .contact-section {
      flex-direction: column; /* Stack vertically on small screens */
    }

    .contact-image {
    width: 100%;
  }

  .contact-image img {
    display: block; /* Show the img tag on smaller screens */
    width: 100%; /* Make image full width */
    height: auto; /* Set the height of the image */
    object-fit: cover; /* Cover the area without stretching the image */
  }

    .contact-content {
      /* Take the full width on small screens */
      flex-basis: 100%;
    }
  }
</style>